'use client'

import { ChakraProvider, defaultSystem } from '@chakra-ui/react'
import { ColorModeProvider } from './color-mode-fixed'

export function Provider(props) {
  return (
    <ChakraProvider value={props.value || defaultSystem}>
      <ColorModeProvider {...props} />
    </ChakraProvider>
  )
}
